import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://mshrronakcbcnapkfmwa.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1zaHJyb25ha2NiY25hcGtmbXdhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NzY4NzgsImV4cCI6MjA5NjE1Mjg3OH0.xnpmUmkAv26Fdgy63CMUvyV9PcxcP0r-u5LX7tdSsrU';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
